const catalogInitialState = {
  catalog: {
    count:              0,
    countModels:        0,
    initialStateLoaded: false,
    installationTypes:  {},
    isInterior:         false,
    items:              [],
    meta:               {},
    modelCount:         0,
    popularModels:      {},
    priceBounds:        null,
    showMore:           false,
    sort:               null,
  },
  element: {
    allowedSeries:        {},
    currentModelId:       null,
    currentOfferGroupId:  null,
    currentOfferId:       null,
    currentSeriesId:      null,
    initialStateLoaded:   false,
    lowPrioritySeriesKey: null,
    meta:                 {},
    models:               {},
    popularModels:        [],
    stb:                  {
      max:    {
        coldProtection:  null,
        draftProtection: null,
        security:        null,
        soundInsulation: null,
      },
      min:    {
        coldProtection:  0.30,
        draftProtection: 50,
        security:        400,
        soundInsulation: 25,
      },
      series: {},
    },
    stbBySeries:          {},
  },
  filter:  {
    catalogItemsLoaded: false,
    filter:             {},
    initialStateLoaded: false,
    items:              [],
    open:               true,
    selectedValues:     {},
  },
  loading: false,
  wait:    false,
};

export default catalogInitialState;